import React, { Component } from "react";
import { Col, Row, DatePicker, Select, Button, Modal, Icon, Input } from "antd";
import { connect } from "react-redux";
import { historyMP } from '../../helper/history';
import { Link } from 'react-router-dom'
import cookie from "react-cookies";
import { getStarred, getAll, changeOrdering, clearAllFilters, setDateRange } from "../../action/search.action";
import moment from 'moment';

var today = new Date();
var dd = today.getDate();

const { RangePicker } = DatePicker;

const Option = Select.Option;

class FilterComp extends Component {
  constructor(props) {
    super(props);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.state = {
      valType: undefined,
      valSort: "-date_time",
      valDateRange: undefined
    };
  }

  handleTypeChange(value) {
    if (value === "starred") {
      this.props.dispatch(getStarred(this.props.urlState));
    } else {
      this.props.dispatch(getAll(this.props.urlState));
    }
  }

  handleSortChange(value) {
    this.props.dispatch(changeOrdering(value, this.props.urlState));
  }

  handleDateRangeChange(moment) {
    try {
      this.props.dispatch(setDateRange(moment[0].format("YYYY-MM-DD"), moment[1].format("YYYY-MM-DD"), this.props.urlState));
    } catch (err) {
      this.props.dispatch(setDateRange('', '', this.props.urlState));
    }
  }

  defaultFilterApply() {
  }

  handleClear() {
    this.props.dispatch(clearAllFilters());
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    var isMobile = cookie.loadAll().isMobile === "true";

    return (
        this.props.isFetching === true ? 
          <Row >
          </Row>
         : 
          <Row style={isMobile ? {height:"6em"} : {}}>
            <Col span={4}>
              <Select
                value={this.props.urlState.starred ? "starred" : "all"}
                placeholder="Select Type"
                onChange={this.handleTypeChange}
                style={{width:120, marginLeft:8}}
              >
                <Option value="starred">Starred</Option>
                <Option value="all">All</Option>
              </Select>
            </Col>
            <Col span={12}>
              <RangePicker
                dateRender={current => {
                  const style = {};
                  if (current.date() === dd) {
                    style.backgroundColor = "transparent";
                    style.color = "black";
                  }
                  return (
                    <div className="ant-calendar-date" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
                showToday
                onChange={this.handleDateRangeChange}
                value={this.props.urlState.date__lte.length === 0 ? undefined : [moment(this.props.urlState.date__gte, "YYYY-MM-DD"), moment(this.props.urlState.date__lte, "YYYY-MM-DD")]}
                format="YYYY-MM-DD"
                defaultValue={[undefined, undefined]}
              />
            </Col>
            <Col span={5}>
              <Select
                value={this.props.urlState.ordering}
                placeholder="Sort List"
                onChange={this.handleSortChange}
                style={{width:130}}
              >
                <Option value="name">
                  {" "}
                  A-Z
                </Option>
                <Option value="-name">
                  {" "}
                  Z-A
                </Option>
                <Option value="date_time">
                  Oldest First
                </Option>
                <Option value="-date_time">
                  Recent First
                </Option>
              </Select>
            </Col>
            <Col span={3}>
              <Button
                style={{
                  marginLeft: 8,
                  backgroundColor: "white",
                  color: "gray"

                }}
                onClick={this.handleClear}
              >
                Clear Filters
              </Button>
            </Col>
          </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    isFetching: state.searchReducer.isFetching,
    loginStatus: state.loginAlerts.loginStatus,
    urlState: state.searchReducer
  };
};

export default connect(mapStateToProps)(FilterComp);
